module.exports = __webpack_public_path__ + "static/media/bank.491d6be0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bank.png
// module id = 39
// module chunks = 0 1